import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsIconRegistry,
} from '@cmps/ng-uikit';
import { mdiFolderAccount, mdiInformation, mdiLoupe } from '@mdi/js';

import { CmpsOpportunityActionGroupComponent } from './opportunity-action-group.component';

@NgModule({
    declarations: [CmpsOpportunityActionGroupComponent],
    exports: [CmpsOpportunityActionGroupComponent],
    imports: [CmpsButtonModule, CmpsIconModule, CommonModule],
})
export class CmpsOpportunityActionGroupModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['information', mdiInformation],
            ['loupe', mdiLoupe],
            ['folder-account', mdiFolderAccount],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
